import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { haptics } from './haptics'

const THRESHOLD = 70

export function usePullToRefresh(onRefresh) {
  const qc = useQueryClient()

  useEffect(() => {
    let startY = null
    let pulling = false

    function onStart(e) {
      if (window.scrollY > 0) return
      startY = e.touches?.[0]?.clientY ?? null
      pulling = false
    }

    function onMove(e) {
      if (startY == null) return
      const dy = (e.touches?.[0]?.clientY ?? 0) - startY
      if (dy > 10) pulling = true
      if (dy > THRESHOLD && !document.body.dataset.ptrTriggered) {
        document.body.dataset.ptrTriggered = '1'
        haptics.bump()
      }
    }

    function onEnd() {
      const triggered = document.body.dataset.ptrTriggered === '1'
      delete document.body.dataset.ptrTriggered
      startY = null
      if (triggered && pulling) {
        onRefresh?.()
        qc.invalidateQueries()
      }
      pulling = false
    }

    document.addEventListener('touchstart', onStart, { passive: true })
    document.addEventListener('touchmove',  onMove,  { passive: true })
    document.addEventListener('touchend',   onEnd)
    return () => {
      document.removeEventListener('touchstart', onStart)
      document.removeEventListener('touchmove',  onMove)
      document.removeEventListener('touchend',   onEnd)
    }
  }, [onRefresh, qc])
}
